export const getUserAgent = () => {
    return navigator.userAgent;
};

export const createConsentRecord = (documentType) => {
    return {
        accepted: true,
        accepted_at: new Date().toISOString(),
        user_agent: getUserAgent(),
        document_type: documentType,
        version: 'v1',
    };
};

export const prepareConsentData = (termsAccepted, privacyAccepted) => {
    const consentData = {};

    if (termsAccepted) {
        consentData.terms_consent = createConsentRecord('terms_of_service');
    }

    if (privacyAccepted) {
        consentData.privacy_consent = createConsentRecord('privacy_policy');
    }

    return consentData;
};
